import { render } from "./TrainingSchemes.vue?vue&type=template&id=31cde2ba&scoped=true"
import script from "./TrainingSchemes.vue?vue&type=script&lang=js"
export * from "./TrainingSchemes.vue?vue&type=script&lang=js"

import "./TrainingSchemes.vue?vue&type=style&index=0&id=31cde2ba&scoped=true&lang=scss"

import exportComponent from "/home/misha/Рабочий стол/sportkit-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31cde2ba"]])

export default __exports__